<template>
  <div class="container">
    <div class="left">
      <div class="title">
        <div class="classroom-name" @click="$router.back()">
          <a-icon class="icon-back" type="left"/>
          {{ `${classroomDetail.campusName || ''} - ${classroomDetail.buildingName || ''} - ${classroomDetail.classroomName || ''}` }}
        </div>
      </div>
      <div class="info1">
        <span class="status">
          状态<a-tag class="status-text" color="#F3D4D3">{{classroomStatus[classroomDetail.status]}}</a-tag>
        </span>
        <span class="time">
          最近使用时间:
          <span class="time-str">{{ classroomDetail.lastUsedTime || '- -' }}</span>
        </span>
      </div>
    </div>
    <div class="right">
      <a-input-search class="search-input" placeholder="请输入课程、老师关键字" @search="onSearch" />
      <div class="info2">
        <p class="using-times">{{ liveTotalCount }}次</p>
        <p class="using-type">教室直播</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleClassroomHeader',
  props: {
    classroomDetail: {
      type: Object,
      default() {
        return {}
      }
    },
    liveTotalCount: {
      type: Number,
      default: 0
    }
  },
  components: {
  },
  data () {
    return {
      searchValue: '',
      classroomStatus: {
        0: '已关机',
        1: '进行中'
      }
    }
  },
  methods: {
    onSearch(value) {
      this.$emit('searchVideoList', {
        searchValue: value,
        pageNum: 1,
        pageSize: 10
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .container {
    background: #DEE6FD;
    padding: 16px 0 16px 16px;
    color: #1E2228;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .left{
      max-width: calc(100% - 360px);
      .title{
        width: 100%;
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 8px;
        .classroom-name{
          width: 100%;
          display: inline-block;
          cursor: pointer;
          // width:400px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          &:hover{
            opacity: 0.8;
          }
        }
        .icon-back{
          color: #000;
          font-size: 18px;
        }
      }
      .info1{
        color: #6F7C91;
        display: flex;

        .status{
          display: flex;
          align-items: center;
          margin-right: 10px;
        }
        .status-text{
          margin-left: 6px;
          color:#CD7875;
        }
      }
    }
    .right{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .search-input{
        width: 240px;
      }
      .info2{
        width: 110px;
        text-align: center;
        .using-times{
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 8px;
        }
        .using-type{
          color: #6F7C91;
        }
      }
    }
  }
</style>